// extracted by css-extract-rspack-plugin
export default {"container":"_318a2d99","tileWidth":"_23bc7aec","desktop3ItemsRow":"_c550b3b3","desktop4ItemsRow":"_d04cb214"};